export const ADD_INGREDIENT = "ADD_INGREDIENT";
export const REMOVE_INGREDIENT = "REMOVE_INGREDIENT";
export const USER = "USER";
export const USER_DEL = "USER_DEL";
export const BURGER = "BURGER";
